module.exports = __webpack_public_path__ + "static/media/tolabaki_logo.0837fabb.png";